import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import StyleSheet from '../../../utils/helpers/styleSheet'
import {
  addImageHistoryItem,
  bringFront,
} from '../../../stores/editor/editor.reducer'
import BringForwardIcon from '../../icons/BringForwardIcon'
import {Img} from '../../../models/editor/img'
import {IMG_SENT_FRONT} from '../../../models/editor/imgHistoryItemAction'
import {useTranslation} from 'react-i18next'

const styles: StyleSheet = {
  button: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 15,
    cursor: 'pointer',
    alignItems: 'center',
  },
  icon: {
    cursor: 'pointer',
    height: '30px',
  },
  text: {
    textAlign: 'center',
    minWidth: 110,
  },
}

export default function BringForwardButton() {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {images, selectedImageId} = useAppSelector(store => store.editor)

  return selectedImageId ? (
    <div
      style={styles.button}
      onClick={() => {
        const img = images.find((image: Img) => image.id === selectedImageId)

        if (img) {
          dispatch(addImageHistoryItem({item: {img, action: IMG_SENT_FRONT}}))
        }
        dispatch(bringFront({id: selectedImageId}))
      }}>
      <BringForwardIcon
        title={t('Előrébb hozás')}
        style={styles.icon}
        className="icon"
        width={30}
        height={30}
      />
      <span style={styles.text} className="text">
        {t('Előrébb hozás')}
      </span>
    </div>
  ) : null
}
